import { z } from 'zod';
/** null is a meaningful value (distinct from omitted); empty string and non-v7-UUIDs are rejected. */
export const nullableUuidString = (invalidMessage) => z
    .string()
    .nullable()
    .superRefine((value, context) => {
    if (value !== null && !z.uuid({ version: 'v7' }).safeParse(value).success) {
        context.addIssue({ code: 'custom', message: invalidMessage, path: [] });
    }
});
//# sourceMappingURL=nullable-uuid-string.js.map